import React from 'react'
import Select, { components } from 'react-select'
import PropTypes from 'prop-types'
import styles from './checkbox.module.css'

const dummyOptions = [
  {
    label: 'Placeholder',
    value: 'Placeholder'
  },
  {
    label: 'Placeholder A',
    value: 'Placeholder1'
  },
  {
    label: 'Placeholder B',
    value: 'Placeholder2'
  },
  {
    label: 'Placeholder C',
    value: 'Placeholder3'
  },
]

// Remove 'X' button
const MultiValueRemove = () => <span></span>

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <div className={`flex ${styles.checkbox}`}>
          <div>
            <input type="checkbox" id={`${props.value.split(' ').join('')}_id`} className="hidden" onChange={e => null} checked={props.isSelected}/>
            <div className={`mr-2 border flex justify-center items-center ${styles.outer}`}>
              <div className={styles.inner}></div>
            </div>
          </div>
          <label className="cursor-pointer text-sm text-gray-444">{props.label}</label>
        </div>

        {/* <input
          type="checkbox"
          checked={props.isSelected}
          onChange={e => null}
        />{" "}
        <label>{props.value} </label> */}
      </components.Option>
    </div>
  )
}

const SelectCheckbox = ({options, ...props}) => {
  return (
    <Select
      closeMenuOnSelect={false}
      isMulti
      styles={{
        option: base => ({
          ...base,
          background: `#fff`,
          color: '#444',
          height: '100%',
        }),
        multiValueLabel: base => ({
          ...base,
          backgroundColor: '#f5f5f5',
          color: '#444',
        }),
      }}
      hideSelectedOptions={false}
      components={{ Option, MultiValueRemove }}
      options={options}
      {...props}
    />
  )
}

SelectCheckbox.propTypes = {
  options: PropTypes.array
}

SelectCheckbox.defaultProps = {
  options: dummyOptions
}

export { SelectCheckbox }